import { motion } from "framer-motion";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { SEEN_ACTIONS } from "@/components/SeenRow";

const COPY = {
  liked: "Put something here by mistake? Swipe it left to move it to Didn't like.",
  disliked: "Actually enjoyed one of these? Swipe it right to move it to Liked.",
  passed: "Changed your mind? Swipe a movie right to add it to your Watchlist.",
};

export function SeenHint({ kind, open, onDismiss }) {
  const action = SEEN_ACTIONS[kind];
  const sign = action.side === "left" ? -1 : 1;
  const Icon = action.icon;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onDismiss()}>
      <DialogContent className="max-w-sm rounded-3xl" data-testid={`seen-hint-${kind}`}>
        <DialogTitle className="font-display text-xl font-black">Fix mistakes with a swipe</DialogTitle>
        <DialogDescription>{COPY[kind]} The button at the end of each row does the same thing.</DialogDescription>
        <div className="relative h-16 rounded-2xl overflow-hidden my-2" aria-hidden>
          <div className={`absolute inset-0 flex items-center px-5 gap-2 text-white font-bold text-sm ${sign < 0 ? "justify-end" : ""}`}
            style={{ background: `hsl(var(${action.color}))` }}>
            <Icon className="h-4 w-4" /> {action.label}
          </div>
          <motion.div animate={{ x: [0, sign * 110, 0] }} transition={{ repeat: Infinity, duration: 2, ease: "easeInOut", repeatDelay: 0.4 }}
            className="absolute inset-0 rounded-2xl border bg-card flex items-center gap-3 px-3">
            <span className="h-11 w-8 rounded-md bg-secondary" />
            <span className="h-3 w-28 rounded-full bg-secondary" />
          </motion.div>
        </div>
        <button onClick={onDismiss} data-testid="seen-hint-dismiss"
          className="h-11 rounded-full bg-primary text-primary-foreground font-bold transition-transform hover:scale-[1.02] active:scale-95">
          Got it
        </button>
      </DialogContent>
    </Dialog>
  );
}
